// Open Filter
class OpenFilter extends HTMLElement {
  constructor() {
    super();

    this.filterLabel = this.querySelector('.js-filter-label');
    this.filterContent = this.querySelector('.js-filter-content');
    this.filterLabel.addEventListener('click', () => {
      this.filterContent.classList.toggle('opened');
      this.filterLabel.classList.toggle('opened');
    });

    this.mainHref = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    if(window.location.href != this.mainHref){
      this.filterContent.classList.add('opened');
      this.filterLabel.classList.add('opened');
    }

    if(this.querySelector('.reset-filter')){
      this.querySelector('.reset-filter').addEventListener('click', () => {
        window.location.href = this.mainHref;
      });
    }
  }
}
customElements.define("button-filter", OpenFilter)


async function getNextPage() {
  try {
    let nextUrl = document.getElementById('product-grid').dataset.nextUrl;
    let res = await fetch(nextUrl);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  const products_on_page = document.getElementById('product-grid');
  let next_url = products_on_page.dataset.nextUrl;

  const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
  load_more_btn.style.display = 'none';
  load_more_spinner.style.display = 'block';
  let nextPage = await getNextPage();

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  load_more_spinner.style.display = 'none';

  const productgrid = nextPageDoc.querySelector('#product-grid');
  const new_products = productgrid.querySelectorAll('.product-card');
  const new_url = productgrid.dataset.nextUrl;
    products_on_page.dataset.nextUrl = new_url;
  if (new_url) {
    load_more_btn.style.display = 'inline-block';
  }
  next_url = new_url;
  console.log(products_on_page);
  for (let i = 0; i < new_products.length; i++) {
    let single_product = new_products[i].cloneNode(true);
    products_on_page.appendChild(single_product);
  }
}


// reload page when select filter
var oldHref = document.location.href;
var bodyList = document.querySelector("body")

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (oldHref != document.location.href) {
            oldHref = document.location.href;
            // window.location.reload();
        }
    });
});

var config = {
    childList: true,
    subtree: true
};

observer.observe(bodyList, config);

history.scrollRestoration = 'manual';
if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
} else {
  window.onbeforeunload = function () {
      window.scrollTo(0, 0);
  }
}
